"use strict";

exports.__esModule = true;
exports["default"] = Webinar;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Webinar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M71.961 338.908h365.154c11.264 0 20.675-9.23 20.675-20.691V64.805c0-11.416-9.411-20.682-20.675-20.682H71.961c-11.37 0-20.564 9.266-20.564 20.682v253.412c-.001 11.461 9.194 20.691 20.564 20.691zM88.245 80.971h331.634v221.09H88.245V80.971zm412.706 386.906H13.02c-20.224 0-7.431-34.779-1.854-42.316 13.152-18.047 34.887-39.943 48.128-53.6 10.526-10.85 16.032-13.332 26.521-14.629h342.356c10.579 1.297 16.014 3.779 26.594 14.629 13.116 13.656 34.994 35.553 48.111 53.6 5.633 7.537 18.318 42.316-1.925 42.316z"
  }));
}